import React from 'react'
import { monthDayYear } from '../helpers/formatters';
import DatePicker from './DatePicker';

export default function DateRange(props = {
    from: "",
    to: "",
    toggle: () => {},
    classes: ""
}) {
    return (
        <div className="form-field">
            <h5 className="label">Date Range</h5>
            <div className="date-box">
                <p className="date-box-text" onClick={(event) => { event.preventDefault(); props.toggle(); }}>
                    {monthDayYear(props.from)} - {monthDayYear(props.to)}
                    <i className="material-icons">date_range</i>
                </p>
                <div className={`DatePickerParent ${props.classes}`}>
                    <DatePicker onDateChange={props.onDateChange} toggle={props.toggle}/>
                </div>
            </div>
        </div>
    )
}